module.exports = __webpack_public_path__ + "static/media/visibility-off-dark.c2c7a00d.svg";